import { render, staticRenderFns } from "./ClockPanel.vue?vue&type=template&id=6be976ee&scoped=true&"
import script from "./ClockPanel.vue?vue&type=script&lang=js&"
export * from "./ClockPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClockPanel.vue?vue&type=style&index=0&id=6be976ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be976ee",
  null
  
)

export default component.exports